<table matSort class="mat-elevation-z8">
  <tr class="trend-th">
    <th>Snapshot</th>
    <th>Monthly</th>
    <th>Yearly</th>
  </tr>
  @for (account of accounts | async; track account) {
    <tr>
      <td class="trend-td" [ngStyle]="{'color': setDiversionColor(account.diversion_rate_daily_average)}">{{ account.diversion_rate_daily_average | percent }}</td>
      <td class="trend-td" [ngStyle]="{'color': setDiversionColor(account.diversion_rate_monthly_average)}">{{account.diversion_rate_monthly_average | percent }}</td>
      <td class="trend-td" [ngStyle]="{'color': setDiversionColor(account.diversion_rate_yearly_average)}">{{account.diversion_rate_yearly_average | percent }}</td>
    </tr>
  }
<!--[ngStyle]="{'color': setDiversionColor(account.diversion_rate_yearly_average)}-->
</table>